import SignupTripForm from "JS/classes/signup/SignupTripForm";

(() => {
    Array.from(document.querySelectorAll('.signup-trip__form')).forEach(form => {
        new SignupTripForm(form);
    });
})();
